import { IAdditionalOutage } from "../store/additionalOutageReducer";

export const SET_ADDITIONAL_OUTAGES = "SET_ADDITIONAL_OUTAGES";
export const SET_AO_COUNTRY = "SET_AO_COUNTRY";
export const SET_AO_LORT = "SET_AO_LORT";
export const SET_AO_VOLTAGE = "SET_AO_VOLTAGE";
export const ADD_ADDITIONAL_OUTAGE = "ADD_ADDITIONAL_OUTAGE";
export const REMOVE_ADDITIONAL_OUTAGE = "REMOVE_ADDITIONAL_OUTAGE";

export const SetAdditionalOutage = (aos: IAdditionalOutage[]) => {
    return { type: SET_ADDITIONAL_OUTAGES, aos };
};
export const SetAOCountry = (country: string) => {
    return { type: SET_AO_COUNTRY, country };
};
export const SetAOLort = (lort: string) => {
    return { type: SET_AO_LORT, lort };
};
export const SetAOVoltage = (voltage: string) => {
    return { type: SET_AO_VOLTAGE, voltage };
};
export const AddAdditionalOutage = (ao: IAdditionalOutage) => {
    return { type: ADD_ADDITIONAL_OUTAGE, ao };
};
export const RemoveAdditionalOutage = (ao: IAdditionalOutage) => {
    return { type: REMOVE_ADDITIONAL_OUTAGE, ao };
};
